import { useMemo } from 'react'
import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  let stepsData = useDataValue({
    context: 'connection_resources',
    viewPath: props.viewPath,
  })

  return useMemo(() => {
    let propertyValues = stepsData.resources[0] || {}

    return {
      steps: stepsData.app.properties.map(property => ({
        id: `${propertyValues.id}-${property.key}`,
        property_id: propertyValues.id,
        name: property.name,
        key: property.key,
        value: propertyValues.properties?.[property.key] || null,
      })),
      current_index: 0,
    }
  }, [])
}
